<template>

  <div class="row" style="height: 100vh">

    <div class="col-3" id="app">
      <div>
        <div class="mb-2">
          <button type="button" class="btn btn-outline-success btn-block" @click="createOrder">Add new order</button>

        </div>
        <div class="list-group">
          <a href="" @click.prevent="editOrder(order)"
             class="list-group-item list-group-item-action flex-column align-items-start" :class="{'active': order.hovered, 'list-group-item-danger': (!order.reservation.reservationTables || !order.reservation.reservationTables.length), 'list-group-item-success': order.reservation.isArrived}" v-for="(order, n) in orders" :key="n">
            <div class="d-flex w-100 justify-content-between">
              <h6 class="mb-1">
                <div v-if="order.icon" class="fa" :class="'fa-' + order.icon"></div>
                {{order.reservation.reservationDate | time}}-{{order.reservation.leavingTime}}
                <span v-if="order.reservation.fullname">
                - {{order.reservation.fullname}}
                </span>
                <span v-if="order.reservation.totalCountForClient > 1" class="fa fa-star"></span>
                <div>Room: {{roomName(order.reservation.reservationRoom)}}, tables: {{(order.reservation.reservationTables || []).join(', ')}}</div>
              </h6>
              <small>
                {{order.reservation.partySize}}
                <span v-if="order.reservation.partySize === 1">person</span>
                <span v-else>people</span>
              </small>
            </div>
          </a>

          <span v-if="!orders.length">
          <el-alert
            center :closable="false"
            title="No orders"
            type="info">
          </el-alert>
          </span>
        </div>
      </div>
    </div>
    <div class="col-9">
      <div id="cc">
        <img id="i" />
        <div style="display: none">
        <canvas id="c"></canvas>
        </div>
      </div>
    </div>

  </div>
</template>
<style scoped>
  #cc {
    width: 100%;
    height: 100%;
    overflow: auto;
  }
  .el-button-group+.el-button-group {
    margin-left: 10px;
  }
</style>
<script>
import moment from 'moment'
import 'fabric'

let canvas;

export default {
  props: ['room', 'orders', 'time', 'rooms'],
  components: {
  },
  filters: {
    date(value) {
      return moment(value).format('DD-MM-YYYY');
    },
    time(value) {
      return moment(value).format('HH:mm');
    }
  },
  computed: {
    loading() {
      return this.$store.state.loading;
    }
  },
  data() {
    return {
      tables: [],
      selectedTable: null
    }
  },
  watch: {
    time() {
      this.updateColors();
      console.info('time')
    },
    room() {
      this.loadRoom();
      setTimeout(() => {
        this.updateColors();
      }, 10);
    },
    orders() {
      this.updateColors();
    }
  },
  mounted() {
    canvas = new fabric.Canvas('c');
    canvas.selection = false;
    canvas.set('selection', false);

    this.loadRoom();
  },
  methods: {
    roomName(val) {
      let roomsArr = this.rooms || {};

      return (roomsArr.find(i => i._id === val) || {}).title;
    },
    loadRoom() {
      canvas.loadFromJSON(this.room.settings || '', () => {
        canvas.setWidth(800);//canvas.backgroundImage.width * canvas.backgroundImage.scaleX);
        canvas.setHeight(800);//canvas.backgroundImage.height * canvas.backgroundImage.scaleY);

        canvas.renderAll();
        this.updateColors();
      }, (o,object) => {
        var tableItem = prepareTableItem({
          title: o.title,
          size: ''
        });
        tableItem.object = object;
        this.tables.push(tableItem);
        object.tableItem = tableItem;
        object.update = updateGroupData;
        object.update(tableItem);
        object.set('selectable', false);
      });
    },
    updateColors() {
      (this.tables || []).forEach(table => {
        table.isGreen = false;
        table.size = '';
        table.fullname = '';
        table.object.update(table);
      });

      const list = (this.orders || []).filter(order => {
        let start = moment(order.reservation.reservationDate);
        let end = moment(start).add(2, 'hours');
        let current = moment(start.format('DD-MM-YYYY') + ' ' + this.time, 'DD-MM-YYYY HH:mm');
        return current.isBetween(start, end) || current.isSame(start) || current.isSame(end);
      });
      list.forEach(item => {
        if (!item.reservation.reservationRoom || !item.reservation.reservationTables || item.reservation.reservationRoom != this.room._id) {
          return;
        }
        (this.tables || []).filter(table => item.reservation.reservationTables.indexOf(table.title) !== -1).forEach(table => {
          table.size = item.reservation.partySize;
          table.fullname = item.reservation.fullname;
          table.isGreen = true;
          table.object.update(table);
        });
      });
      canvas.renderAll();
      document.getElementById('i').src = canvas.toDataURL('png');
    },
    createOrder() {
      this.$emit('new-order')
    },
    editOrder(order) {
      console.info(order);
      this.$emit('edit-order', JSON.parse(JSON.stringify(order)))
    }
  }
};

function updateGroupData(data) {
  this.item(0).set('fill', data.isGreen ? '#5fba7d' : 'rgba(200,200,200,0.5)');

  this.item(1).set('text', data.title);

  var size = data.size;

  this.item(2).set('text', data.fullname ? `${data.fullname} (${size})` : '');
  this.item(2).set('fontSize', 18);
}

function prepareTableItem(o) {
  return {
    title: o.title,
    size: ''
  };
}

</script>



// WEBPACK FOOTER //
// ViewRoom.vue?4ba266f1